import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, TransitionGroup as _TransitionGroup, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "toast-container" }
const _hoisted_2 = {
  key: 0,
  class: "mb-3 rounded-sm bg-white p-3 shadow-sm"
}

import BaseToast from '@/components/base/BaseToast.vue'
import { useToasts } from '@/core/composables/useToasts'
import { useI18n } from 'vue-i18n'


export default /*@__PURE__*/_defineComponent({
  __name: 'AppToastContainer',
  setup(__props) {

const { toasts, removeToast, numHiddenToasts } = useToasts()
const { t } = useI18n()

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(numHiddenToasts))
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_unref(t)('toasts.pending', _unref(numHiddenToasts))), 1))
      : _createCommentVNode("", true),
    _createVNode(_TransitionGroup, {
      tag: "span",
      class: "flex flex-col gap-y-3",
      "enter-from-class": "translate-x-8 opacity-0",
      "enter-active-class": "transition duration-300 ease-out",
      "leave-active-class": "transition duration-300 ease-in",
      "leave-to-class": "translate-x-10 opacity-0"
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(toasts), (toast) => {
          return (_openBlock(), _createBlock(BaseToast, {
            key: toast.id,
            toast: toast,
            onClose: _unref(removeToast)
          }, null, 8, ["toast", "onClose"]))
        }), 128))
      ]),
      _: 1
    })
  ]))
}
}

})